<template>
	<div>
		<el-dialog
			:close-on-click-modal="false"
			append-to-body
			:visible.sync="visible"
			title="公告"
			width="980px"
			center
		>
			<div style="padding: 0 40px;">
				<el-carousel trigger="click" :autoplay="false" arrow="hover" height="400px" @change="change">
					<el-carousel-item v-for="(item, index) in noticeList" :key="index">
						<div class="contentBox" style="height: 100%; display: flex; flex-direction: column;">
							<h1 style="text-align: center;">{{ item.title }}</h1>
							<div  style="flex: 1;">
								<div v-html="item.content"></div>
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="visible = false">我已知悉</el-button>
				<!-- <el-button type="text" @click="allReadAndClose">关闭</el-button> -->
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { getUserMessagePage } from '@/api/system/messageCenter/messageCenter'

	export default {
		name: "noticeDialog",
		props: {},
		data() {
			return {
				visible: false,
				noticeList: [],
			}
		},
		watch: {
			noticeList(newVal) {
				this.visible = newVal.length > 0
			},
		},
		created() {
			// 获取五条未读的弹窗消息
			this.getUserMessageList({page: 1, size: 5, remind: '1', status: '0', sysNotice: true}).then(res => {
				this.noticeList = res
				// 一进来就标记第一条已读
				if(this.noticeList.length) {
					let currentView = this.noticeList[0]
					this.$store.dispatch("markMessageHaveRead", currentView.id, currentView.messageType)
				}
			})
		},
		methods: {
			// 获取消息列表
			getUserMessageList(params = {}) {
				return getUserMessagePage(params).then(res => res.records || [])
			},
			// 幻灯片改变
			change(index) {
				let currentView = this.noticeList[index]
				this.$store.dispatch("markMessageHaveRead", currentView.id, currentView.messageType)
			},
			// 全部已读并关闭
			allReadAndClose() {
				// this.$store.dispatch("markMessageHaveReadAll")
				this.visible = false
			},
		},
	}
</script>

<style scoped lang="scss">
	.contentBox {
		overflow: auto;
		border-radius: 4px;
		padding: 15px 60px;
		// background-color: rgba(243, 243, 243, 0.7);
		// box-shadow: 1px 1px rgba(243, 243, 243, 0.7);
		// color: #5a5e66;
	}

	/deep/ .el-carousel__button {
		background-color: #999;

	}
	/deep/ .el-carousel__button.is-active {
			background-color: #333;
		}
</style>
